module.exports = "<input type=\"checkbox\" class=\"switch\" [checked]=\"checked\"\r\n                      [value]=\"value\" (change)=\"changeSwitch($event)\">"